/* @flow */
export const HIGH = "HIGH";
export const MEDIUM = "MEDIUM";
export const LOW = "LOW";
export type REQUEST_PRIORITY = typeof HIGH | typeof MEDIUM | typeof LOW;
